export default __webpack_public_path__ + "static/media/banner-3.ae7be47c.jpg";